import { makeAutoObservable } from 'mobx';
import { ENDPOINT, HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { IHttpService } from 'src/services/http.service';
export interface ICheckingSelfieImageStore {
	checking(file: File): Promise<boolean>;
}

export class CheckingSelfieImageStore implements ICheckingSelfieImageStore {
	constructor(protected readonly http: IHttpService) {
		makeAutoObservable(this);
	}
	public async checking(file: File): Promise<boolean> {
		const form = new FormData();

		form.append('file', file);

		const res = await this.http.uploadFile(ENDPOINT.CHECK_SELFIE_IMAGE, form);

		if (res.responseKey === HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			return res.data as boolean;
		}

		return false;
	}
}
